<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h1>Extraction</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="ibox">
          <a @click.prevent="openExportCsvModal('perfs')" title="Exporter en CSV">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Extraction</dt>
                  <dd>Suivi des performances</dd>
                </dl>
              </div>
              <h2><i class="far fa-file-csv fa-xs"></i></h2>
            </div>
          </a>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="ibox">
          <a @click.prevent="openExportCsvModal('products')" title="Exporter en CSV">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Extraction</dt>
                  <dd>Produits à la vente commandés</dd>
                </dl>
              </div>
              <h2><i class="far fa-file-csv fa-xs"></i></h2>
            </div>
          </a>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="ibox">
          <a @click.prevent="openExportCsvModal('all_references')" title="Exporter en CSV">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Extraction</dt>
                  <dd>Toutes les références uniques</dd>
                </dl>
              </div>
              <h2><i class="far fa-file-csv fa-xs"></i></h2>
            </div>
          </a>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="ibox">
          <a @click.prevent="openExportCsvModal('all_products')" title="Exporter en CSV">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Extraction</dt>
                  <dd>Tous les produits à la vente</dd>
                </dl>
              </div>
              <h2><i class="far fa-file-csv fa-xs"></i></h2>
            </div>
          </a>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="ibox">
          <a @click.prevent="openExportCsvModal('all_users')" title="Exporter en CSV">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Extraction</dt>
                  <dd>Tous les utilisateurs de la boutique</dd>
                </dl>
              </div>
              <h2><i class="far fa-file-csv fa-xs"></i></h2>
            </div>
          </a>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="ibox">
          <a @click.prevent="openExportCsvModal('all_business_returns')" title="Exporter en CSV">
            <div class="ibox-content indicator">
              <div class="flex-grow-1">
                <dl>
                  <dt>Extraction</dt>
                  <dd>Tous les retours matériels</dd>
                </dl>
              </div>
              <h2><i class="far fa-file-csv fa-xs"></i></h2>
            </div>
          </a>
        </div>
      </b-col>
    </b-row>

    <b-modal id="export_modal" lazy hide-footer centered no-close-on-backdrop size="lg" @hidden="stopExportPolling">
      <template slot="modal-title">
        <i class="far fa-download"></i>
        Exporter en CSV
      </template>
      <p v-if="currentHasPeriod">
        Vous pouvez sélectionner une plage de date, uniquement une date de début ou une date de fin,
        ou laisser vide pour exporter l'intégralité des données.
      </p>
      <p class="text-muted">
        Le fichier est généré en arrière-plan : vous pouvez fermer cette fenêtre, la génération
        se poursuit sur le serveur.
      </p>
      <b-form inline class="align-items-end m-b" @submit.prevent="exportCsv">
        <b-form-group label="Du " label-for="start_date" v-if="currentHasPeriod">
          <datepicker id="start_date" input-class="form-control ml-2" v-model="start_date" :format="'dd/MM/yyyy'"
            :language="fr" :clear-button="true" :monday-first="true" clear-button-icon="fa fa-times fa-lg"></datepicker>
        </b-form-group>
        <b-form-group label="Au" label-for="end_date" v-if="currentHasPeriod">
          <datepicker id="end_date" input-class="form-control ml-2" v-model="end_date" :format="'dd/MM/yyyy'"
            :language="fr" :clear-button="true" :monday-first="true" clear-button-icon="fa fa-times fa-lg"></datepicker>
        </b-form-group>
        <b-button type="submit" variant="primary" :disabled="exportLoading" class="ml-auto">
          {{
            exportLoading
              ? "Génération..."
              : currentHasPeriod
                ? "Exporter pour la période"
                : "Exporter toutes les données"
          }}
          <i v-if="!exportLoading" class="fa fa-chevron-right"></i>
        </b-button>
        <b-button v-if="exportLoading && exportId" variant="outline-secondary" class="ml-2" :disabled="cancelling"
          @click="cancelExport">
          <i class="fa fa-times"></i>
          {{ cancelling ? "Annulation..." : "Annuler" }}
        </b-button>
      </b-form>

      <ExportProgress :steps="exportSteps" :running="exportLoading" :elapsed-label="exportElapsedLabel"
        :percent="exportPercent" />

      <div class="form-submit" v-if="exportReady">
        <b-button variant="primary" :disabled="downloading" @click="downloadExport">
          Télécharger le fichier CSV
          <i class="fa fa-chevron-right"></i>
        </b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import ExportProgress from "@/components/Global/ExportProgress";
import dataExportMixin from "@/mixins/dataExport";

/**
 * Les extractions sont générées en tâche de fond par le worker Messenger (cf. mixin dataExport) :
 * on crée l'extraction, on suit son avancement en direct, puis on télécharge le CSV.
 */
export default {
  name: "Exports",
  components: {
    Datepicker,
    ExportProgress,
  },
  // Création, suivi (étapes, chronomètre) et téléchargement de l'extraction
  mixins: [dataExportMixin],
  data() {
    return {
      en: en,
      fr: fr,
      start_date: null,
      end_date: null,
      currentExport: null,
      // Extractions bornées par une période
      periodExports: ["perfs", "products", "all_business_returns"],
      // Libellé de l'étape serveur, par extraction
      exportExtractLabel: {
        perfs: "Extraction du suivi des performances",
        products: "Extraction des produits à la vente commandés",
        all_references: "Extraction de toutes les références uniques",
        all_products: "Extraction de tous les produits à la vente",
        all_users: "Extraction des utilisateurs de la boutique",
        all_business_returns: "Extraction des retours matériels",
      },
    };
  },
  computed: {
    currentHasPeriod() {
      return this.periodExports.includes(this.currentExport);
    },
  },
  methods: {
    openExportCsvModal(currentExport) {
      this.currentExport = currentExport;
      this.resetDataExport();
      this.$root.$emit("bv::show::modal", "export_modal");
    },
    exportCsv() {
      this.startDataExport(
        {
          type: this.currentExport,
          start_date: this.currentHasPeriod && this.start_date ? this.$moment(this.start_date).format("YYYY-MM-DD") : null,
          end_date: this.currentHasPeriod && this.end_date ? this.$moment(this.end_date).format("YYYY-MM-DD") : null,
        },
        this.exportExtractLabel[this.currentExport]
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.ibox a {
  color: $text;

  &:hover {
    color: $primary;
  }
}

.ibox-content {
  font-size: 12px;

  dl {
    margin-bottom: 0;

    dt {
      margin-bottom: 0;
    }

    dd {
      clear: both;
      @extend .clanprobold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Exports.vue